import {ref, Ref} from '@vue/composition-api';
import {WebGLRenderer} from 'three/src/renderers/WebGLRenderer';

export class EditorDialogWebGLCapabilitiesStoreControllerClass {
	private static _instance: EditorDialogWebGLCapabilitiesStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorDialogWebGLCapabilitiesStoreControllerClass());
	}

	private _renderer: WebGLRenderer | undefined;
	private _displayed!: Ref<boolean>;
	private constructor() {}

	init() {
		this._displayed = ref(false);
	}

	// getters
	displayed(): boolean {
		return this._displayed.value;
	}
	renderer() {
		return this._renderer;
	}

	// mutations
	async show(renderer: WebGLRenderer): Promise<string> {
		this._renderer = renderer;
		return new Promise((resolve, reject) => {
			this._displayed.value = true;
		});
	}
	hide() {
		this._displayed.value = false;
		this._renderer = undefined;
	}
}

export const EditorDialogWebGLCapabilitiesStoreController =
	EditorDialogWebGLCapabilitiesStoreControllerClass.instance();
